// @flow
import * as React from 'react';
import { useLocation, Redirect } from 'react-router-dom';

import { useAuth } from 'common/modules/auth';
import SessionFetcher from './SessionFetcher';

import { LocusApiModel } from 'common/modules/api';

type Props = { children: React.Node };

const AppAuthenticationManager = ({ children }: Props): React.Node => {
    const auth = useAuth();
    const location = useLocation();

    if (!auth.isAuthenticated) {
        return (
            <Redirect
                to={{
                    pathname: '/login',
                    state: { fromLocation: location }
                }}
            />
        );
    }

    if (auth.authHeader) {
        LocusApiModel.setHeader(auth.authHeader.key, auth.authHeader.value);
    }

    return <SessionFetcher>{children}</SessionFetcher>;
};

export default AppAuthenticationManager;
